import styled from 'styled-components';

import BaseCheckbox from '~/onboarding/components/check-box/check-box';

export const Checkbox = styled(BaseCheckbox)``;
